var map = {
	"./de-AT.json": "2ba9",
	"./de-CH.json": "c776",
	"./de-DE.json": "6922",
	"./de.json": "6ce2",
	"./en-AT.json": "a2e1",
	"./en-CH.json": "c2b6",
	"./en-NL.json": "e6d6",
	"./en.json": "edd4",
	"./nl-NL.json": "0727"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";